const TYPEID_PURCHASE = 8;
const TYPEID_PURCHASE_OPENBOX = 9;
const TYPEID_RENT_TO_OWN = 10;
const TYPEID_RENT_TO_OWN_OPENBOX = 53;
const TYPEID_LOAN = 11;

const ordered_item_types = [TYPEID_PURCHASE, TYPEID_PURCHASE_OPENBOX, TYPEID_RENT_TO_OWN, TYPEID_RENT_TO_OWN_OPENBOX, TYPEID_LOAN];

function ModemListingsViewModel(modems) {
	const self = this;

	self.lang = document.documentElement.lang || "en";

	self.isLoading = ko.observable(true);

	self.purchaseDevices = ko.observableArray();
	self.availableDevices = ko.observableArray();

	self.getHardwareHighlights = get_hardware_highlights;
	self.getHardwareSpecs = get_hardware_specs;
	self.getHardwareDescription = get_hardware_description;
	self.getCommunityLink = get_community_link;
	self.getHardwareFees = get_hardware_fees;
	self.getOpenBoxHardwareFees = get_openbox_hardware_fees;
	self.hasWifi = has_wifi;
	self.selectedHardware = ko.observable(null);
	
	self.formatHardwareVersion = function (hardwareVersion) {
		return "v" + hardwareVersion;
	};

	self.viewHardware = function (item) {
		self.selectedHardware(item);
		document.getElementById("internet-hardware-slideout").classList.add("expand");
	};

	const allModems = modems || [];
	allModems.sort((up, down) => {
		return up["make"] === down["make"] ? 0 : up["make"] > down["make"] ? 1 : -1;
	});
	
	allModems.forEach((mod) => {
		if (mod["fees"] && mod["fees"].length > 0) {
			self.purchaseDevices.push(mod);
		}

		if (mod["hardwareGroup"] !== "Router") {
			self.availableDevices.push(mod);
		}
	});	  

	self.closeExpandedSlideout = function () {
		self.selectedHardware(null);
	};

	self.viewHardwareFeatures = function () {
		document.getElementById("hardware-nav-tabs-slider").classList.remove("slide");
		document.getElementById("hardwarespecs-tab").classList.remove("active");
		document.getElementById("hardwarefeatures-tab").classList.add("active");
		document.getElementById("internet-hardware-slideout-features").classList.add("show");
		document.getElementById("internet-hardware-slideout-specs").classList.remove("show");
	};

	self.viewHardwareSpecs = function () {
		document.getElementById("hardware-nav-tabs-slider").classList.add("slide");
		document.getElementById("hardwarespecs-tab").classList.add("active");
		document.getElementById("hardwarefeatures-tab").classList.remove("active");
		document.getElementById("internet-hardware-slideout-specs").classList.add("show");
		document.getElementById("internet-hardware-slideout-features").classList.remove("show");
	};
}

function get_hardware_description(item) {
	const lang = document.documentElement.lang || "en";
	return item.hardwareDescription[lang];
};

function get_community_link(item) {
	if (!item.hardwareLinkUrls) return;
	return item.hardwareLinkUrls['TekSavvyCommunity'];
};

function learnMore(data, event) {
	event.stopPropagation();
	if (!window.modemApp) return;
	window.modemApp.viewHardware(data);
}

function closeOnClickOutside(event) {
	if (document.body.classList.contains('touch')) return; // skip the click outside thing, the slideouts fill the screen on small screens
	if (!window.modemApp) return;
	const element = document.querySelector(".slideout.expand");
	if (!element || element.id === event.currentTarget.id || element.contains(event.target)) {
		return;
	}
	// i.e. if there is an open slideout AND the click target is not the slideout or something in it...
	window.modemApp.closeExpandedSlideout();
}

document.addEventListener("click", closeOnClickOutside);

function has_wifi(features) {
	if (!features) return false;
	const { wireless } = features;
	if (!wireless) return false;
	if (wireless.length === 0) return false;
	return true;
};

function get_hardware_fees(item) {
	if (!item["fees"] || item["fees"].length === 0) {
		return [];
	}

	const results = [];
	const lang = document.documentElement.lang || "en";
	const allFees = item["fees"];

	for (let i = 0; i < ordered_item_types.length; i++) {
		const currentItemType = ordered_item_types[i];
		const modemFee = allFees.find((f) => f["itemTypeID"] === currentItemType);
		if (!modemFee) continue;

		const name = modemFee["name"][lang];

		if (lang === "en") {
			interval = (modemFee["costInterval"] === "per" ? "" : "/month").toLowerCase();
			interval2 = (modemFee["costInterval"] === "Monthly" ? "months" : "").toLowerCase();
		} else {
			interval = (modemFee["costInterval"] === "per" ? "" : "/ mois").toLowerCase();
			interval2 = (modemFee["costInterval"] === "Monthly" ? "mois" : "").toLowerCase();
		}

		const price = modemFee["price"];
		const nums = price.toFixed(2).split(".");

		if (lang === "en") {
			switch (modemFee["itemTypeID"]) {
				case TYPEID_LOAN:
					results.push(
						`<div class="modem-fee-type">Loan for</div>
						<div class="modem-fee-price-container">
							<div class="modem-fee-price-dollars">$${nums[0]}</div>
							<div class="modem-fee-price-cents-container">
								<div class="modem-fee-price-cents">${nums[1]}</div>
								<div class="modem-fee-length">${interval}</div>
							</div>
						</div>`);
					break;
				case TYPEID_RENT_TO_OWN:
					results.push(
						`<div class="modem-fee-type">Rent-to-own for</div>
						<div class="modem-fee-price-container">
							<div class="modem-fee-price-dollars">$${nums[0]}</div>
							<div class="modem-fee-price-cents-container">
								<div class="modem-fee-price-cents">${nums[1]}</div>
								<div class="modem-fee-length">/${modemFee["rtoLength"]} ${interval2}</div>
							</div>
						</div>`);
					break;
				case TYPEID_PURCHASE:
					results.push(
						`<div class="modem-fee-type">Purchase for</div>
						<div class="modem-fee-price-container">
							<div class="modem-fee-price-dollars">$${nums[0]}</div>
							<div class="modem-fee-price-cents">${nums[1]}</div>
						</div>`);
					break;
			}
		} else {
			switch (modemFee["itemTypeID"]) {
				case TYPEID_PURCHASE:
					results.push(
						`<div class="modem-fee-type">Acheter le</div>
						<div class="modem-fee-price-container">
							<div class="modem-fee-price-dollars">$${nums[0]}</div>
							<div class="modem-fee-price-cents-container">
								<div class="modem-fee-price-cents">${nums[1]}</div>
								<div class="modem-fee-length">${interval}</div>
							</div>
						</div>`
					);
					break;
				case TYPEID_RENT_TO_OWN:
					results.push(
						`<div class="modem-fee-type">Location avec option d'achat pour</div>
						<div class="modem-fee-price-container">
							<div class="modem-fee-price-dollars">$${nums[0]}</div>
							<div class="modem-fee-price-cents-container">
								<div class="modem-fee-price-cents">${nums[1]}</div>
								<div class="modem-fee-length">/${modemFee["rtoLength"]} ${interval2}</div>
							</div>
						</div>`
					);
					break;
				case TYPEID_LOAN:
					results.push(		
						`<div class="modem-fee-type">Prêt pour</div>
						<div class="modem-fee-price-container">
							<div class="modem-fee-price-dollars">$${nums[0]}</div>
							<div class="modem-fee-price-cents-container">
								<div class="modem-fee-price-cents">${nums[1]}</div>
								<div class="modem-fee-length">${interval}</div>
							</div>
						</div>`
					);
					break;
			}
		}
	}


	return results;
}

function get_openbox_hardware_fees(item) {
	if (!item["fees"] || item["fees"].length === 0) {
		return [];
	}

	const results = [];
	const lang = document.documentElement.lang || "en";
	const allFees = item["fees"];

	for (let i = 0; i < ordered_item_types.length; i++) {
		const currentItemType = ordered_item_types[i];
		const modemFee = allFees.find((f) => f["itemTypeID"] === currentItemType);
		if (!modemFee) continue;

		const name = modemFee["name"][lang];

		if (lang === "en") {
			interval = (modemFee["costInterval"] === "per" ? "" : "/month").toLowerCase();
			interval2 = (modemFee["costInterval"] === "Monthly" ? "months" : "").toLowerCase();
		} else {
			interval = (modemFee["costInterval"] === "per" ? "" : "/ mois").toLowerCase();
			interval2 = (modemFee["costInterval"] === "Monthly" ? "mois" : "").toLowerCase();
		}

		const price = modemFee["price"];
		const nums = price.toFixed(2).split(".");

		if (lang === "en") {
			switch (modemFee["itemTypeID"]) {
				case TYPEID_PURCHASE_OPENBOX:
					results.push(
						`<div class="modem-fee-type">Purchase for</div>
						<div class="modem-fee-price-container">
							<div class="modem-fee-price-dollars">$${nums[0]}</div>
							<div class="modem-fee-price-cents">${nums[1]}</div>
						</div>`
					);
					break;
				case TYPEID_RENT_TO_OWN_OPENBOX:
					results.push(
						`<div class="modem-fee-type">Rent-to-own for</div>
						<div class="modem-fee-price-container">
							<div class="modem-fee-price-dollars">$${nums[0]}</div>
							<div class="modem-fee-price-cents-container">
								<div class="modem-fee-price-cents">${nums[1]}</div>
								<div class="modem-fee-length">/${modemFee["rtoLength"]} ${interval2}</div>
							</div>
						</div>`
					);
					break;
			}
		} else {
			switch (modemFee["itemTypeID"]) {
				case TYPEID_PURCHASE_OPENBOX:
					results.push(
						`<div class="modem-fee-type">Acheter le</div>
						<div class="modem-fee-price-container">
							<div class="modem-fee-price-dollars">$${nums[0]}</div>
							<div class="modem-fee-price-cents">${nums[1]}</div>
						</div>`
					);
					break;
				case TYPEID_RENT_TO_OWN_OPENBOX:
					results.push(
						`<div class="modem-fee-type">Location avec option d'achat pour</div>
						<div class="modem-fee-price-container">
							<div class="modem-fee-price-dollars">$${nums[0]}</div>
							<div class="modem-fee-price-cents-container">
								<div class="modem-fee-price-cents">${nums[1]}</div>
								<div class="modem-fee-length">/${modemFee["rtoLength"]} ${interval2}</div>
							</div>
						</div>`
					);
					break;
			}
		}
	}


	return results;
}

function get_hardware_highlights(item) {
	const lang = document.documentElement.lang || "en";
	return item.featureDescriptions[lang];
}

function get_hardware_specs(item) {
	const lang = document.documentElement.lang || "en";
	return item.hardwareSpecifications[lang];
}

addLoadEvent(function () {
	if (MODEMS_NODE && typeof MODEMS_NODE !== "undefined") {
		const url = document.getElementById("modems").dataset.url;
		if (!url) return;

		fetch(url)
			.then((response) => response.json())
			.then((json) => {
				window.modemApp = new ModemListingsViewModel(json);
				ko.applyBindings(window.modemApp, MODEMS_NODE);
				window.modemApp.isLoading(false);
			});
	}
});
